<div class="container">
  <router-outlet></router-outlet>
</div>

<ng-content select="[modal]"></ng-content>
